import React from "react";
import { InboxOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import schema from "../datasets/schema.json";
import {
  message,
  Upload,
  Button,
  Typography,
  Avatar,
  List,
  Popover,
} from "antd";
import { Link } from "react-router-dom";
import { QuestionCircleOutlined } from "@ant-design/icons";

const Validator = require("jsonschema").Validator;

const { Dragger } = Upload;
const { Title } = Typography;

const createImageDataset = (d) => {
  var allImages = d.map((a) => a.images);
  allImages = [].concat.apply([], allImages);
  var allImagesTitles = allImages.map((img) => img.title);

  var cleanImages = allImages.filter(
    (item, index, self) =>
      index === self.findIndex((t) => t.title === item.title)
  );

  cleanImages.forEach((img) => {
    const repetitions = allImagesTitles.filter(
      (title) => title == img.title
    ).length;
    img.repetitions = repetitions;
  });

  return cleanImages;
};

const Data = () => {
  const navigate = useNavigate();

  // Feedback messages for the dataset upload
  const [messageApi, contextHolder] = message.useMessage();

  const success = () => {
    messageApi.open({
      key: "message",
      type: "success",
      content: "JSON file uploaded successfully",
      duration: 1,
    });
  };

  const error = () => {
    messageApi.open({
      key: "message",
      type: "error",
      content: "Incorrect JSON file",
    });
  };

  const loading = () => {
    messageApi.open({
      key: "message",
      type: "loading",
      content: "Loading JSON file..",
      duration: 0,
    });
  };

  // Check if there is a data link in the url and load it
  const checkDataLink = () => {
    const queryString = window.location.hash.split("?").at(-1);
    const urlParams = new URLSearchParams(queryString);

    if (urlParams.has("data")) {
      loading();

      setTimeout(function () {
        const sampleData = urlParams.get("data");

        fetch(sampleData)
          .then((response) => response.json())
          .then(function (json) {
            var jsonData = json;

            var v = new Validator();

            var response = v.validate(jsonData, schema).valid;

            if (response) {
              var info = jsonData.info;
              var data = jsonData.data;
              window.$data = data;
              window.$imageData = createImageDataset(data);
              window.$infoData = info;
              success();

              setTimeout(function () {
                navigate("/about");
                setTimeout(function () {
                  navigate("/dashboard");
                }, 0.1);
              }, 1500);
            } else {
              error();
            }
          });
      }, 500);
    }
  };

  // Uploader properties
  const props = {
    name: "file",
    accept: ".json",
    showUploadList: false,
    beforeUpload(file) {
      loading();

      setTimeout(function () {
        let reader = new FileReader();
        reader.onload = (e) => {
          var jsonData = JSON.parse(e.target.result);

          var v = new Validator();

          var response = v.validate(jsonData, schema).valid;

          if (response) {
            var info = jsonData.info;
            var data = jsonData.data;
            window.$data = data;
            window.$imageData = createImageDataset(data);
            window.$infoData = info;
            success();
            setTimeout(function () {
              window.location.hash = "";
              navigate("#/about");
              setTimeout(function () {
                window.location.hash = "";
                navigate("#/dashboard");
              }, 1);
            }, 1500);
          } else {
            error();
          }
        };
        reader.readAsText(file);

        return false;
      }, 500);
    },
  };

  const sampleList = [
    {
      title: "Wikiproject chemistry",
      date: "26/07/2023",
      dataset:
        "https://raw.githubusercontent.com/Aquets/VCAT-data-extractor/main/Examples/wp_Chemistry.json",
      link: "https://en.wikipedia.org/wiki/Wikipedia:WikiProject_Chemistry",
      icon: "https://upload.wikimedia.org/wikipedia/commons/5/59/Nuvola_apps_edu_science.svg",
    },
    {
      title: "Wikiproject Neuroscience",
      date: "26/07/2023",
      dataset:
        "https://raw.githubusercontent.com/Aquets/VCAT-data-extractor/main/Examples/wp_Neuroscience.json",
      link: "https://en.wikipedia.org/wiki/Wikipedia:WikiProject_Neuroscience",
      icon: "https://upload.wikimedia.org/wikipedia/commons/2/21/Brain_human_normal_inferior_view.svg",
    },
    {
      title: "Wikiproject Eclipses",
      date: "26/07/2023",
      dataset:
        "https://raw.githubusercontent.com/Aquets/VCAT-data-extractor/main/Examples/wp_Eclipses.json",
      link: "https://en.wikipedia.org/wiki/Wikipedia:WikiProject_Eclipses",
      icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Solar_eclipse_1999_4.jpg/487px-Solar_eclipse_1999_4.jpg",
    },
  ];

  const popOverContent = (
    <>
      Use the <Link to="/extraction">extraction tool</Link> to extract the .JSON
      data file
    </>
  );

  function refreshPage(params = "") {
    if (params == "") {
      window.location.reload(false);
    } else {
      window.location.href += `?${params}`;
      window.location.reload(false);
    }
  }

  return (
    <div className="text-container">
      <div style={{ display: "flex", alignItems: "center" }}>
        <Title level={4}>Upload your data</Title>
        <Popover content={popOverContent}>
          <Button
            type="link"
            shape="circle"
            icon={<QuestionCircleOutlined />}
          />
        </Popover>
      </div>
      <div className="divider-medium"></div>

      {contextHolder}
      {
        (window.onload = function () {
          checkDataLink();
        })
      }

      <Dragger {...props} style={{ width: "700px" }}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag a .JSON file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Extract a data file using the extraction tool.
        </p>
      </Dragger>
      <div className="divider-medium"></div>
      <div className="divider-medium"></div>

      <Title level={4}>Use a sample</Title>
      <div className="divider-medium"></div>

      <List
        itemLayout="horizontal"
        dataSource={sampleList}
        style={{ textAlign: "left", width: "500px" }}
        renderItem={(item, index) => (
          <List.Item>
            <List.Item.Meta
              avatar={<Avatar src={item.icon} />}
              title={
                <a href={item.link} target="_blank">
                  {item.title}
                </a>
              }
              description={`Extracted on: ${item.date}`}
            />
            <Button
              onClick={() => refreshPage(`data=${item.dataset}`)}
              type="link"
            >
              Load data
            </Button>
          </List.Item>
        )}
      />
      <div className="divider-medium"></div>
    </div>
  );
};

export default Data;
